import { useCallback, useEffect, useRef, useState } from 'react';
import { api, type UserNotifications } from './api';
import { BILDIRIM as M } from './metin/bildirim';
import { ORTAK, tamSayi, tarihSaat } from './metin/ortak';
import { musteriYolu, YOLLAR } from './yonlendirme';

export function BildirimZili({ userId, git }: { userId: string; git: (path: string) => void }) {
  const [data, setData] = useState<UserNotifications | null>(null);
  const [error, setError] = useState(false);
  const panel = useRef<HTMLDivElement>(null);
  const load = useCallback(async () => {
    try { setData(await api.notifications()); setError(false); } catch { setError(true); }
  }, []);
  useEffect(() => {
    setData(null);
    void load();
    const timer = window.setInterval(() => { if (!document.hidden) void load(); }, 60000);
    return () => window.clearInterval(timer);
  }, [load, userId]);
  async function read(id: string) {
    try { await api.readNotification(id); await load(); } catch { setError(true); }
  }
  return <div className="bildirim">
    <button type="button" className="bildirim-zili" popoverTarget="bildirim-panel" aria-label={M.baslik} onClick={() => { void load(); }} data-testid="bildirim-zili">
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M9 21h6" /></svg>
      {data && data.unreadCount > 0 ? <span data-testid="bildirim-sayisi" aria-label={`${tamSayi(data.unreadCount)} ${M.okunmamis}`}>{tamSayi(data.unreadCount)}</span> : null}
    </button>
    <div id="bildirim-panel" popover="auto" className="bildirim-panel" ref={panel} aria-label={M.baslik}>
      <h2>{M.baslik}</h2>
      {error ? <div role="alert"><p>{M.hata}</p><button type="button" onClick={() => { void load(); }}>{ORTAK.yeniden}</button></div> : null}
      {!data && !error ? <p>{M.yukleniyor}</p> : null}
      {data?.items.length === 0 ? <p>{M.bos}</p> : null}
      <ul>{data?.items.map((item) => {
        const talep = item.webDemandId !== null;
        const hedef = talep || item.customerId === null ? YOLLAR.v3 : musteriYolu(item.customerId);
        return <li key={item.id} data-testid="bildirim-satiri" data-unread={!item.readAt}>
          {talep
            ? <p>{item.kind === 'WEB_DEMAND_STALE_ESCALATION' ? M.talepYonetici(item.waitingHours ?? 0) : M.talepSahip(item.waitingHours ?? 0)}</p>
            : <><p>{M.atama}</p><strong>{item.customer?.displayName}</strong></>}
          <p><time dateTime={item.createdAt}>{tarihSaat(item.createdAt)}</time></p>
          <a href={hedef} onClick={(event) => {
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault(); void read(item.id); panel.current?.hidePopover(); git(hedef);
          }}>{talep ? M.talepAc : M.ac}</a>
          {!item.readAt ? <button type="button" onClick={() => { void read(item.id); }}>{M.okundu}</button> : null}
        </li>;
      })}</ul>
      {data && data.items.length >= 50 ? <p>{M.kapsam}</p> : null}
    </div>
  </div>;
}
